import React, {useEffect, useState, useRef} from 'react';
import propTypes from 'prop-types';
import {get, groupBy, findIndex, pickBy, keys, sortBy, throttle} from 'lodash';
import {gql} from 'apollo-boost';
import styled from 'styled-components';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import jaycoClient from '../../graphql/jaycoClient';
import merge from 'deepmerge';
import Accordion from '../../components/ui/Accordion';
import {theme} from '../../themes/default-theme';
import Text from '../../components/typography';
import {Switch} from '../../components/ui';
import ReactHtmlParser from 'react-html-parser';



const GET_MODEL_DATA = gql`
  query FILTER_GET_MODEL_FEATURES($filter: [ModelModelFilterInput]) {
    listModels(limit:1000, filter: {
      or: $filter
    }) {
      items {
        id
        name
        productType
        productSeries
        spec
        travelLength
        travelHeight
        widthIncAwning
        interiorHeight
        BodyLength
        openLength
        weightTare
        weightTowBall
        weightLoading
        marketingCategory
        priceNZ
        priceAU
        priceAUNSW
        priceAUACT
        priceAUVIC
        priceAUQLD
        priceAUSA
        priceAUWA
        priceAUTAS
        priceAUNT
        features {
          items {
            id
            category
            group
            description
            updatedAt
            createdAt
          }
        }
      }
    }
  }
`

const Wrapper = styled.div`
  position: relative;
`

const TableHead = styled.div`
  background: ${theme.palette.vividBlue};
  color: white;
  display: table;
  width: 100%;
  position: absolute;
  top: 0;
  transition: top 300ms ease;

  ${props => props.fixed === 1 && `
    position: fixed;
    z-index: 3;
    top: 71px;
    ${theme.breakpoints.up('md')} {
      top: 87px;
    }
    ${props.maxWidth && `
      max-width: ${props.maxWidth}px;
    `}
  `}
`

const TableHeadParent = styled.div`
  height: ${props => props.height}px;
  position: relative;
`

const TableHeadCell = styled.div`
  display: table-cell;
  width: 20%;
  text-align: center;
  vertical-align: middle;
  padding: 17px 0;

  // p {
  //   text-transform: uppercase;
  //   font-size: 11px;
  //   font-weight: bold;
  // }

  ${props => props.cellWidth !== null && `
    width: ${props.cellWidth};
  `}

  ${props => props.autoWidth === 1 && `
    width: auto;
  `}

  ${theme.breakpoints.down('sm')} {
    width: 50%;
    padding: 17px;
    // p {
    //   font-size: 10px;
    // }
  }

  &:first-child {
    width: 40%;
    text-align: left;
    padding-left: 16px;

    ${props => props.autoWidth === 1 && `
      width: auto;
    `}

    ${theme.breakpoints.down('sm')} {
      width: 50%;
    }

    h6 {
      margin: 0;
      display: inline-block;
    }
  }

  p {
    margin: 0 auto;
    padding: 0 10px;
  }

  ${theme.breakpoints.down('sm')} {
    ${props => props.differences === 1 && `
      display: none;
    `}
  }
`

const CompareSwitchContainer = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: -2px;

  ${theme.breakpoints.down('sm')} {
    h6 {
      margin: 0;
      display: inline-block;
    }
  }
`

const CompareSwitchWrapper = styled.div`
  display: inline-block;
  margin-left: 17px;
`

const CompareSwitchLabel = styled.div`

`

const MobileSwitchContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  label {
    margin-right: 0;
    > span {
      margin-left: 5px;
    }
  }

  h6 {
    margin: 0;
    display: inline-block;
  }

  ${theme.breakpoints.up('md')} {
    display: none;
    
  }
`

const CompareTable = (props) => {
  const {
    items
  } = props

  const [data, updateData] = useState(null);
  const [compare, setCompare] = useState(false);
  const [tableHeadPosition, setTableHeadPosition] = useState(false);
  const [accordionActive, setAccordionActive] = useState(null);
  const accordionActiveRef = useRef(accordionActive);

  const tableHead = useRef(null);
  const tableHeadParent = useRef(null);
  const accordionRef = useRef(null);

  const onScroll = () => {
    if (accordionActiveRef.current && tableHead.current && tableHeadParent.current) {
      const isMobile = window.outerWidth < 940
      const navHeight = isMobile ? 71 : 87 // not needed now
      const parentPosition = tableHeadParent.current.getBoundingClientRect();
      const height = tableHead.current.clientHeight;
      const isFixed = (parentPosition.top) <= (navHeight - height);
      const accordionPosition = accordionRef.current.getBoundingClientRect();
      if ((accordionPosition.bottom - navHeight) <= 0) {
        setTableHeadPosition('bottom');
      } else {
        setTableHeadPosition(isFixed ? 'top' : 'static');
      }
    } else {
      setTableHeadPosition('static');
    }
  }

  const handleAccordionChange = (active) => {
    setAccordionActive(active);
    accordionActiveRef.current = active
  }

  useEffect(() => {
    onScroll();
  }, [accordionActive])

  useEffect(() => {
    if (tableHeadPosition === 'top') {
      document.body.classList.add('hide-desktop-nav');
    } else {
      document.body.classList.remove('hide-desktop-nav');
    }
  }, [tableHeadPosition])

  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll, {passive: true});
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [])

  useEffect(() => {

    const getData = async () => {

      const queryFilter = items.map(item => {
        return {
          id: {
            contains: get(item, 'model.value', null)
          }
        }
      });

      console.log('ccc', queryFilter);

      const result = await jaycoClient.query({
        query: GET_MODEL_DATA,
        variables: {
          filter: queryFilter
        }
      });

      const data = get(result, 'data.listModels.items', null);

      if (data) {

        const compareData = data.map(modelItem => {
          const groupedFeatures = get(modelItem, 'features.items', null) ? groupBy(modelItem.features.items, item => item.group) : null;

          console.log('ccc modelItem', modelItem);
          console.log('ccc groupedFeatures', groupedFeatures);
          const features = Object.keys(groupedFeatures).map(key => {
            // Immutable js wouldn't work for me here so had to go the long way...
            const groupFeatures = [];
            const duplicateFeatures = [];
            const mergedFeatures = [];
            const featureItems = groupedFeatures[key];

            for (let item of featureItems) {
              const duplicateIndex = findIndex(groupFeatures, {category: item.category});
              if (duplicateIndex === -1) {
                groupFeatures.push(item);
              } else {
                duplicateFeatures.push(item);
              }
            }

            groupFeatures.forEach((item, index) => {
              const indexes = keys(pickBy(duplicateFeatures, {category: item.category}));
              let description = item.description
              indexes.forEach((duplicateIndex) => {
                const duplicateDesription = get(duplicateFeatures[duplicateIndex], 'description', '')
                if (duplicateDesription) {
                  description += `, ${duplicateDesription}`
                }
              });
              mergedFeatures.push({
                ...item,
                description
              })
            })
            
            return {title: key.toLowerCase().replace(/^.{1}/g, key[0].toUpperCase()), items: mergedFeatures, layoutId: modelItem.id}
          });

          const specifications = {
            title: 'Specifications',
            layoutId: modelItem.id,
            items: [{
              id: 'interiorHeight',
              group: 'SPECIFICATIONS',
              category: 'Interior height (mm)',
              description: modelItem.interiorHeight
            },{
              id: 'travelHeight',
              group: 'SPECIFICATIONS',
              category: 'Travel height (mm)',
              description: modelItem.travelHeight
            },{
              id: 'travelLength',
              group: 'SPECIFICATIONS',
              category: 'Travel length (mm)',
              description: modelItem.travelLength
            },{
              id: 'BodyLength',
              group: 'SPECIFICATIONS',
              category: 'Body length (mm)',
              description: modelItem.BodyLength
            },{
              id: 'openLength',
              group: 'SPECIFICATIONS',
              category: 'Open length (mm)',
              description: modelItem.openLength
            },{
              id: 'widthIncAwning',
              group: 'SPECIFICATIONS',
              category: 'Width inc awning (mm)',
              description: modelItem.widthIncAwning
            },{
              id: 'weightTare',
              group: 'SPECIFICATIONS',
              category: 'Weight tare (kg)',
              description: modelItem.weightTare
            },{
              id: 'weightLoading',
              group: 'SPECIFICATIONS',
              category: 'Weight loading (kg)',
              description: modelItem.weightLoading
            },{
              id: 'weightTowBall',
              group: 'SPECIFICATIONS',
              category: 'Weight tow ball (kg)',
              description: modelItem.weightTowBall
            }]
          }

          return {
            features: [...[specifications], ...sortBy(features, ['title'], ['asc'])]
          }

        });


        let featuresObjArr = []
        let features = {};

        compareData.forEach(compareItem => {

          let featureItems = {};
        
          compareItem.features.forEach(item => {
            const title = item.title;

            item.items.forEach(featureItem => {
              if (!featureItems[title]) {
                featureItems[title] = {}
              }
              featureItems[title][featureItem.category] = {
                [item.layoutId]: featureItem.description
              }
            })

            features[title] = featureItems
          });

          featuresObjArr.push(featureItems)
   
        });

        const mergedFeaturesObjArr = merge.all(featuresObjArr);
        

        const compareItems = items.map(item => {
          return get(item, 'model.value', null);
        });

        let compareAccordions = [];
        Object.keys(mergedFeaturesObjArr).map(key => {
          let accordionRows = [];
          Object.keys(mergedFeaturesObjArr[key]).map(rowKey => {
            let accordionCols = {};
            Object.keys(mergedFeaturesObjArr[key][rowKey]).map(colKey => {
              // Check if compareItems is missing a colKey
              compareItems.forEach(compareItem => {
                let hasItem = get(mergedFeaturesObjArr, `[${key}][${rowKey}][${compareItem}]`, null)
                if (!hasItem) {
                  accordionCols[compareItem] = '-'
                } else {
                  accordionCols[colKey] = mergedFeaturesObjArr[key][rowKey][colKey]
                }
              })
            })
            accordionRows.push({
              category: rowKey,
              cols: accordionCols
            })
          })
          key.toLowerCase() !== 'decor' && compareAccordions.push({
            title: key,
            rows: accordionRows
          })
        })

        updateData(compareAccordions)

        // if (compareItems.length !== items.length) {
        //   console.warn('floorplan is missing from api...', compareItems, items);
        // }
      }
    }

    getData();
    onScroll();
  }, [items])

  const maxWidth = tableHeadParent.current ? tableHeadParent.current.clientWidth : null;
  const tableHeadHeight = tableHead.current ? tableHead.current.clientHeight : 82;

  return (
  	<Wrapper ref={accordionRef}>
      {data &&
        <>
          {/* <MobileSwitchContainer>
            <CompareSwitch onChange={() =>setCompare(!compare)} checked={compare} mobile={true}/>
          </MobileSwitchContainer> */}
          <TableHeadParent ref={tableHeadParent} fixed={tableHeadPosition === 'top' ? 1 : 0} height={tableHeadHeight}>
            <TableHead ref={tableHead} fixed={tableHeadPosition === 'top' ? 1 : 0} maxWidth={maxWidth}>
              <TableHeadCell differences={1} autoWidth={props.cellWidth ? 1 : 0}>
                <CompareSwitch onChange={() =>setCompare(!compare)} checked={compare}/>
              </TableHeadCell>

              {items.map(item => {
                const rangeTitle = item.range.toLowerCase();
                const size = (rangeTitle.indexOf('jpod') === -1 && rangeTitle.indexOf('j-pod') === -1 && rangeTitle.indexOf('camper trailers') === -1) ? get(item, 'model.text', null) : null;
                return (
                  <TableHeadCell key={item.uniqueId} cellWidth={props.cellWidth}>
                    <Text variant="subtitle1" colour="white" uppercase align="center"><p>{item.title}<br />{item.spec}{size && ReactHtmlParser(`&nbsp;|&nbsp;${size}`)}</p></Text>
                  </TableHeadCell>
                )
              })}

              {props.showBlankCell &&
                <TableHeadCell cellWidth={props.cellWidth}>
                  &nbsp;
                </TableHeadCell>
              }
              
            </TableHead>
          </TableHeadParent>
          <Accordion
            data={data}
            compare={true}
            highlight={compare}
            compareItems={items}
            activeBg="middleGrey"
            onExpand={handleAccordionChange}
            cellWidth={props.cellWidth}
            showBlankCell={props.showBlankCell}
            firstActive={true}
          />
          
        </>
      }
    </Wrapper>
  )
}

const CompareSwitch = ({checked, onChange, mobile}) => {
  return(
    <>
      <Text variant="subtitle1" colour={mobile ? 'charcoal' : 'white'}>Show Differences:</Text>
      <CompareSwitchWrapper>
        <Text variant="subtitle1" colour={mobile ? 'charcoal' : 'white'}>OFF</Text>
        <CompareSwitchContainer>
          <FormControlLabel
            control={
              <Switch
                checked={checked} 
                onChange={() => onChange()} 
                name="show_differences" 
              />
            }
          />
        </CompareSwitchContainer>
        <Text variant="subtitle1" colour={mobile ? 'charcoal' : 'white'}>ON</Text>
      </CompareSwitchWrapper>
    </>

  )
}
  
CompareTable.propTypes = {
  cellWidth: propTypes.string,
  showBlankCell: propTypes.bool
}
  
CompareTable.defaultProps = {
  cellWidth: null,
  showBlankCell: false
}
  
export default CompareTable